import React, { useState, useEffect } from "react";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import "../../styles/style.css";
import "../../styles/payout.css";
import "../../styles/upi-mandate.css";
import { Tabs, Tab } from "react-tabs";
import trashIcon from "../../assets/images/trash-03.svg";
import editIcon from "../../assets/images/edit_btn.svg";
import plusWhite from "../../assets/images/plus-white.svg";
import reject from "../../assets/images/reject.svg";
import comment from "../../assets/images/comment.svg";
import clipboard from "../../assets/images/clipboard.svg";

import Offcanvas from "react-bootstrap/Offcanvas";
import {
  getComplaintsList,
  compaintStatusUpdate,
  complaintAddComment,
  fetchCommentList,
  UpdateComment,
  DeleteComment,
} from "../../action/complaints";
import Pagination from "../pagination/paginationView";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import { Loader } from "../loader";
import { Modal } from "react-bootstrap";
import { toast } from "react-hot-toast";
import moment from "moment";
import { useNavigate, useParams } from "react-router-dom";
import { complaintStatusEnum } from "../../enumTypes/enums";
import { getEnumIndexByValue, getKeyByValue } from "../../helper/helper";
import { Link } from "react-router-dom";
import showNotification from "../notification/showNotification";
import { useFormik } from "formik";
import { SingleErrorMessage } from "../../pages/singleErrorMessage";

const InProgressRequest = () => {
  const payloadAcceptComplaint = {
    status: getKeyByValue(complaintStatusEnum, complaintStatusEnum.ACCEPT),
    estimatedTime: "",
  };
  const payloadCompleteComplaint = {
    status: getKeyByValue(complaintStatusEnum, complaintStatusEnum.COMPLETE),
    remark: "",
  };
  const payloadRejectComplaint = {
    status: getKeyByValue(complaintStatusEnum, complaintStatusEnum.REJECT),
    remark: "",
  };

  const [complaintList, setComplaintList] = useState({
    loading: false,
    data: [],
    totalRecords: 0,
  });
  const [acceptStatus, setAcceptStatus] = useState({
    showModel: false,
    loading: false,
    payload: payloadAcceptComplaint,
    id: "",
  });
  const [showImage, setShowImage] = useState(null);
  const [completeStatus, setCompleteStatus] = useState({
    showModel: false,
    loading: false,
    payload: payloadCompleteComplaint,
    id: "",
  });
  const [rejectStatus, setRejectStatus] = useState({
    showModel: false,
    loading: false,
    payload: payloadRejectComplaint,
    id: "",
  });
  const [error, setError] = useState({ message: "", status: "" });
  const navigate = useNavigate();
  const [tabIndex, setTabIndex] = useState(0);
  const params = useParams();
  console.log("parmas", params.status);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [complaint, setComplaint] = useState({
    id: "",
    byId: "",
  });
  console.log("complaint", complaint);
  const [commentId, setCommentId] = useState("");
  const [showCommentModel, setShowCommentModel] = useState(false);
  const [deleteModel, setDeleteModel] = useState(false);
  const [showEditCommentModel, setShowEditCommentModel] = useState(false);
  const [commentCanvas, setCommentCanvas] = useState(false);
  const [commentList, setCommentList] = useState({
    showModel: false,
    loading: false,
    data: [],
    id: "",
  });
  const getComplaintList = async (status) => {
    setComplaintList((k) => ({
      ...k,
      loading: true,
    }));
    const response = await getComplaintsList(
      pageSize,
      pageNo,
      "ACCEPT"
      // getKeyByValue(complaintStatusEnum, status)
    );
    console.log("gey", getKeyByValue(complaintStatusEnum, status));
    if (response.status) {
      setComplaintList((k) => ({
        ...k,
        loading: false,
        data: response?.data?.list,
        totalRecords: response?.data?.count,
      }));
    }
  };
  // getKeyByValue(complaintStatusEnum, status)
  const handleUpdateStatus = (id, handler) => {
    handler((k) => ({
      ...k,
      showModel: true,
      id,
    }));
  };
  const addCommentFormik = useFormik({
    initialValues: {
      comment: "",
      complaintId: "",
      commentTo: "",
    },
    onSubmit: async (values) => {
      console.log("values", values);
      const response = await complaintAddComment(values);
      if (response.status) {
        getComment();
        setShowCommentModel(false);
        addCommentFormik.handleReset();
        showNotification(
          "Comment Added Successfully!",
          response?.message,
          "success"
        );
      } else {
        showNotification("eror", response?.message, "danger");
        setShowCommentModel(false);
      }
      addCommentFormik.handleReset();
    },
  });
  const EditCommentFormik = useFormik({
    initialValues: {
      comment: "",
      complaintId: "",
      commentTo: "",
    },
    onSubmit: async (values) => {
      console.log("values", values);
      const response = await UpdateComment(commentId, values);
      if (response.status) {
        showNotification(
          "Comment Updated Successfully!",
          response.message,
          "success"
        );
        setShowEditCommentModel(false);
        EditCommentFormik.handleReset();
        getComment();
      } else {
        showNotification("Update Comment", response.message, "danger");
        setShowEditCommentModel(false);
      }
      EditCommentFormik.handleReset();
    },
  });
  const closeAndResetComplaintStatusModel = (type) => {
    if (type === complaintStatusEnum.ACCEPT) {
      setAcceptStatus({
        showModel: false,
        loading: false,
        payload: payloadAcceptComplaint,
        id: "",
      });
    } else if (type === complaintStatusEnum.COMPLETE) {
      setCompleteStatus({
        showModel: false,
        loading: false,
        payload: payloadCompleteComplaint,
        id: "",
      });
    } else if (type === complaintStatusEnum.REJECT) {
      setRejectStatus({
        showModel: false,
        loading: false,
        payload: payloadRejectComplaint,
        id: "",
      });
    }
    setError({ message: "", status: "" });
  };
  const isValidatedUpdateForm = (state) => {
    for (const key in state.payload) {
      // Check if the key is empty or undefined
      if (!state.payload[key]) {
        setError({
          message: `Required field`, // Custom error message based on the missing key
          status: state.payload.status,
        });
        return false;
      }
    }
    return true;
  };
  const handleComplaintStatus = async (state) => {
    console.log(state.payload.status, "pay");
    if (!isValidatedUpdateForm(state)) {
      return;
    }

    const response = await compaintStatusUpdate(state.id, state.payload);
    if (response.status) {
      getComplaintList(params.status);
      closeAndResetComplaintStatusModel(
        complaintStatusEnum[`${state.payload.status}`]
      );
      showNotification(
        "Success!",
        "Status Updated Successfully",
        "success"
      );
        if (state.payload.status == "COMPLETE") {
      navigate("/complaints/completed");
    }
    if (state.payload.status == "REJECT") {
      navigate("/complaints/rejected");
    }

    } else {
      showNotification(
        "Eror!",
        response.message,
        "danger"
      );
      // n
    }
  };
  const getComment = async () => {
    const response = await fetchCommentList(pageNo, pageSize, complaint.id);
    if (response?.status) {
      setCommentList((k) => ({
        ...k,
        loading: false,
        data: response?.data?.list,
        totalRecords: response?.data?.count,
      }));
    }
  };
  const deleteCommentData = async () => {
    const response = await DeleteComment(commentId);
    if (response.status) {
      getComment();
      showNotification("Deleted!", response.message, "success");
      setDeleteModel(false);
    } else {
      showNotification("Eror", response.message, "danger");
    }
  };
  const handleTabChange = (index) => {
    const status = Object.values(complaintStatusEnum)[index];
    if (status) {
      navigate(`/complaints/${status}`);
    }
  };

  useEffect(() => {
    getComplaintList(params.status);
    setTabIndex(getEnumIndexByValue(complaintStatusEnum, params.status));
  }, [pageNo, pageSize, params.status]);
  useEffect(() => {
    getComment();
  }, [complaint]);

  return (
    <div className="payout_data-content" style={{ height: "100%" }}>
      <div className="payout_data-head">
        <div className="payout_data-head-top mb-2">
          <div className="payout_data-left">
            <div className="payout_data_ttl">
              {" "}
              <Breadcrumb
                paths={[{ name: "Complaints" }, { name: "Accept" }]}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="tab_box">
        <Tabs
          selectedIndex={tabIndex}
          onSelect={(index) => handleTabChange(index)}
        >
          {/* <TabList>
            {Object.keys(complaintStatusEnum).map((key) => (
              <Tab key={key}>{complaintStatusEnum[key]}</Tab>
            ))}
          </TabList> */}
          <div className="table-responsive">
            <table className="payout_table upi-mandate_table">
              <thead>
                <tr className="tableHead">
                  <th className="thHeader">
                    <div className="payoutHead hndIcon">Ticket ID</div>
                  </th>
                  <th className="thHeader">
                    <div className="payoutHead hndIcon">Department</div>
                  </th>
                  <th className="thHeader">
                    <div className="payoutHead hndIcon">Complaint Title</div>
                  </th>
                  <th className="thHeader">
                    <div className="payoutHead hndIcon">Complaint Count</div>
                  </th>
                  <th className="thHeader">
                    <div className="payoutHead hndIcon">Created Date</div>
                  </th>
                  <th className="thHeader">
                    <div className="payoutHead hndIcon">Attachment</div>
                  </th>

                  <th className="thHeader">
                    <div className="payoutHead hndIcon">
                      Estimated Date to Complete
                    </div>
                  </th>

                  <th className="thHeader">
                    <div className="payoutHead hndIcon">Action</div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {complaintList.loading ? (
                  <tr>
                    <td colSpan="10">
                      <Loader />
                    </td>
                  </tr>
                ) : (
                  <>
                    {complaintList.data?.length > 0 ? (
                      complaintList.data?.map((item) => {
                        return (
                          <tr key={item._id}>
                            <td>{item?.ticket}</td>
                            <td>{item?.departmentDetails?.name}</td>
                            <td>{item?.feed?.title || "-"}</td>
                            <td>
                              {item?.totalComplains ? (
                                <Link to={`/complaint/history/${item._id}`}>
                                  {item.totalComplains}
                                </Link>
                              ) : (
                                "0"
                              )}
                            </td>

                            <td>
                              {item?.createdAt
                                ? moment(item.createdAt).format("DD MMM YYYY")
                                : "-"}
                            </td>
                            {/* <td>
                              {item?.complaints?.length
                                ? item?.complaints.map((el, i) => {
                                  return (
                                    <div key={`attach-${i}`}>
                                      <span
                                        style={{
                                          cursor: "pointer",
                                          textDecoration: "underline",
                                        }}
                                        onClick={() =>
                                          setShowImage(
                                            process.env.REACT_APP_S3_URL +
                                            "/" +
                                            el.image
                                          )
                                        }
                                      >
                                        File {i + 1}
                                      </span>
                                    </div>
                                  );
                                })
                                : ""}
                            </td> */}
                            <td>
                              <span
                                style={{
                                  cursor: "pointer",
                                  textDecoration: "underline",
                                }}
                                onClick={() =>
                                  setShowImage(
                                    process.env.REACT_APP_S3_URL +
                                    "/" +
                                    item?.image
                                  )
                                }
                              >
                                File
                              </span>
                            </td>
                            <td>
                              {item?.estimatedTime
                                ? moment(item.estimatedTime).format(
                                  "DD MMM YYYY"
                                )
                                : "-"}
                            </td>

                            <td>
                              <div className="flex_btn">
                                <button
                                  className="compl_btn"
                                  onClick={() =>
                                    handleUpdateStatus(
                                      item._id,
                                      setCompleteStatus
                                    )
                                  }
                                >
                                  {/* clipboard */}
                                  <img
                                    src={clipboard}
                                    alt="complete"
                                    title="complete"
                                  />
                                </button>

                                <button
                                  className="compl_btn reject"
                                  onClick={() =>
                                    handleUpdateStatus(
                                      item._id,
                                      setRejectStatus
                                    )
                                  }
                                >
                                  {/* Reject */}
                                  <img
                                    src={reject}
                                    alt="reject"
                                    title="reject"
                                  />
                                </button>

                                <button
                                  className="compl_btn"
                                  onClick={() => {
                                    setCommentCanvas(true);
                                    setComplaint({
                                      id: item?._id,
                                      byId: item?.createdBy,
                                    });
                                  }}
                                >
                                  {/* comment */}
                                  <img src={comment} alt="comment" />
                                </button>
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="10" className="text_center">
                          No data available
                        </td>
                      </tr>
                    )}
                  </>
                )}
              </tbody>
            </table>
          </div>
        </Tabs>
        {complaintList.data?.length > 0 ? (
          <Pagination
            currentPage={pageNo}
            totalCount={complaintList.totalRecords}
            pageSize={pageSize}
            onPageChange={(page) => setPageNo(page)}
            changePageSize={(page) => {
              setPageSize(page);
              setPageNo(1);
            }}
          />
        ) : (
          <></>
        )}

        <Modal
          show={completeStatus.showModel}
          centered
          onHide={() => {
            closeAndResetComplaintStatusModel(complaintStatusEnum.COMPLETE);
          }}
        >
          {/* <Modal.Header closeButton>
          </Modal.Header> */}
          <Modal.Body>
            <Modal.Title>Complete</Modal.Title>
            <div className="input-box">
              <div className="input-label">Remarks</div>
              <textarea
                className="textarea_input"
                rows={5}
                cols={20}
                name="remarks"
                placeholder="Please Enter Your Remark"
                value={completeStatus?.payload?.remark || ""}
                onChange={(e) => {
                  setError({ message: "", status: "" });
                  setCompleteStatus((k) => {
                    k.payload.remark = e.target.value;
                    return { ...k };
                  });
                }}
              ></textarea>
              {error.status ===
                getKeyByValue(
                  complaintStatusEnum,
                  complaintStatusEnum.COMPLETE
                ) && (
                  <span className="text-small text-danger">{error.message}</span>
                )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn btn-dark"
              variant="secondary"
              onClick={() => {
                closeAndResetComplaintStatusModel(complaintStatusEnum.COMPLETE);
              }}
            >
              Cancel
            </button>
            <button
              className="btn btn-success"
              variant="primary"
              onClick={() => {
                handleComplaintStatus(completeStatus);
              }}
            >
              Submit
            </button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={rejectStatus.showModel}
          centered
          onHide={() => {
            closeAndResetComplaintStatusModel(complaintStatusEnum.REJECT);
          }}
        >
          {/* <Modal.Header closeButton>
          </Modal.Header> */}
          <Modal.Body>
            <Modal.Title>Reject</Modal.Title>
            <div className="input-box">
              <div className="input-label">Remarks</div>
              <textarea
                className="textarea_input"
                rows={5}
                cols={20}
                name="remarks"
                placeholder="Please Enter Your Remark"
                value={rejectStatus?.payload?.remark || ""}
                onChange={(e) => {
                  setError({ message: "", status: "" });
                  setRejectStatus((k) => {
                    k.payload.remark = e.target.value;
                    return { ...k };
                  });
                }}
              ></textarea>
              {error.status ===
                getKeyByValue(
                  complaintStatusEnum,
                  complaintStatusEnum.REJECT
                ) && (
                  <span className="text-small text-danger">{error.message}</span>
                )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn btn-dark"
              variant="secondary"
              onClick={() => {
                closeAndResetComplaintStatusModel(complaintStatusEnum.REJECT);
              }}
            >
              Cancel
            </button>
            <button
              className="btn btn-success"
              variant="primary"
              onClick={() => {
                handleComplaintStatus(rejectStatus);
              }}
            >
              Submit
            </button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={showImage}
          centered
          onHide={() => {
            setShowImage(null);
          }}
        >
          <Modal.Body>
            <div
              className="input-box"
              style={{ maxHeight: "60vh", overflow: "hidden" }}
            >
              <img src={showImage} alt="" />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              className={"btn btn-dark"}
              onClick={() => {
                setShowImage(null);
              }}
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={deleteModel}
          centered
          onHide={() => {
            setDeleteModel(false);
          }}
        >
          <Modal.Body>
            <div className="add_buyer_content">
              <div className="commentHead">
                Are you sure you want to delete comment?
              </div>
              <div className="flex_btn mt-3 justify-content-end mb-3">
                <button
                  className="btn btn-danger"
                  type="button"
                  onClick={() => {
                    setDeleteModel(false);
                  }}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-success"
                  type="button"
                  onClick={() => {
                    deleteCommentData(commentId);
                  }}
                >
                  delete
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
        <Offcanvas
          show={commentCanvas}
          onHide={() => {
            setCommentCanvas(false);
          }}
          placement="end"
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Comments</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="add_buyer_conten">
              <div className="flex_btn my-3 px-3">
                <button
                  className="btn btn-info addbbtn"
                  onClick={() => {
                    setShowCommentModel(true);
                    addCommentFormik.setFieldValue("complaintId", complaint.id);
                    addCommentFormik.setFieldValue("commentTo", complaint.byId);
                  }}
                >
                  Add Comment
                  <img src={plusWhite} alt="" className="payout_down" />
                </button>
              </div>
              <div className="commentTable">
                <table className="payout_table upi-mandate_table">
                  <tr className="tableHead">
                    <th className="thHeader">
                      <div className="payoutHead hndIcon">Comment</div>
                    </th>
                    <th className="thHeader">
                      <div className="payoutHead hndIcon">Action</div>
                    </th>
                  </tr>
                  {commentList.data?.map((data) => {
                    return (
                      <tr>
                        <td>{data?.comment}</td>
                        <td>
                          <div className="flex_btn-box justify-content-lg-start gap-2 mt-0">
                            <div className="flex_btn">
                              <img
                                alt="editIcon"
                                src={editIcon}
                                className="i_button"
                                onClick={() => {
                                  EditCommentFormik.setFieldValue(
                                    "comment",
                                    data?.comment
                                  );
                                  EditCommentFormik.setFieldValue(
                                    "complaintId",
                                    data?.complaintId
                                  );
                                  EditCommentFormik.setFieldValue(
                                    "commentTo",
                                    data?.commentTo
                                  );
                                  setShowEditCommentModel(true);
                                  setCommentId(data?._id);
                                }}
                              />
                            </div>
                            <div
                              className="flex_btn"
                              onClick={() => {
                                setCommentId(data?._id);
                                setDeleteModel(true);
                              }}
                            >
                              <img
                                src={trashIcon}
                                alt="trashIcon"
                                className="i_button"
                              />
                            </div>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </table>
              </div>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
        <Modal
          show={showCommentModel}
          centered
          onHide={() => {
            setShowCommentModel(false);
          }}
        >
          <Modal.Body>
            <div className="add_buyer_content">
              <div className="commentHead">Add Comment</div>

              <form action="" onSubmit={addCommentFormik.handleSubmit}>
                <div className="row">
                  <div className="input-box mt-4">
                    <div className="input_field">
                      <input
                        required
                        name="comment"
                        className="input"
                        type="text"
                        placeholder="Enter Your Comment"
                        value={addCommentFormik.values.comment}
                        onChange={addCommentFormik.handleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="flex_btn mt-3 justify-content-end mb-3">
                  <button className="btn btn-success" type="submit">
                    Add comment
                  </button>
                </div>
              </form>
            </div>
          </Modal.Body>
        </Modal>
        <Modal
          show={showEditCommentModel}
          centered
          onHide={() => {
            setShowEditCommentModel(false);
          }}
        >
          <Modal.Body>
            <div className="add_buyer_content">
              <div className="commentHead">Edit Comment</div>
              <form action="" onSubmit={EditCommentFormik.handleSubmit}>
                <div className="row">
                  <div className="input-box mt-4">
                    <div className="input_field">
                      <input
                        required
                        name="comment"
                        className="input"
                        type="text"
                        placeholder="Enter Your Comment"
                        value={EditCommentFormik.values.comment}
                        onChange={EditCommentFormik.handleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="flex_btn mt-3 justify-content-end mb-3">
                  <button className="btn btn-success" type="submit">
                    Update Comment
                  </button>
                </div>
              </form>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
};

export default InProgressRequest;
